import { render } from "./High52Signal.vue?vue&type=template&id=2bcfab70&scoped=true"
import script from "./High52Signal.vue?vue&type=script&lang=js"
export * from "./High52Signal.vue?vue&type=script&lang=js"

import "./High52Signal.vue?vue&type=style&index=0&id=2bcfab70&scoped=true&lang=scss"

import exportComponent from "/var/www/eztrade-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bcfab70"]])

export default __exports__